export enum MarkStatusEnum {
    Invalid = 0,  
    Submitted = 1,
    Autosaved = 2
}
